module.exports = __webpack_public_path__ + "static/media/132-bosnia-and-herzegovina.bd9d5ff8.svg";